/**
 * @file Dashboard overview page: the agency's key figures and the entry points to the coaches.
 * Failure path: each saga's `onError` resets its loading flag, and the saga shows the message.
 */
import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import DashboardWillMount from "../../../Middleware/Middlewares/DashboardWillMount";
import * as ReactHighcharts from "react-highcharts";
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Card from '@material-ui/core/Card';
import { TabsComponent } from "./TabsComponent";
import { UnitInterface } from "../../../Entity/Entities/Unit/UnitInterface";
import { CoachNewContractDialog } from "../../Partials/Dialog/CoachNewContractDialog";
import { CoachNewUnitDialog } from "../../Partials/Dialog/CoachNewUnitDialog";
import { CoachNewPropertyDialog } from "../../Partials/Dialog/CoachNewPropertyDialog";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { CoachDialog } from "../../Partials/Dialog/CoachDialog";
import { CoachIncreaseRentDialog } from "../../Partials/Dialog/CoachIncreaseRentDialog";
import { CoachNewTenantDialog } from "../../Partials/Dialog/CoachNewTenantDialog";
import ChargeCreateDialog from "../../Partials/Dialog/ChargeCreateDialog";
import { CoachNewPropertyFirstUserDialog } from "../../Partials/Dialog/CoachNewPropertyFirstUserDialog";
import { CoachCreateCreditInvoice } from "../../Partials/Dialog/CoachCreateCreditInvoice";
import CoachNewCharge from "../../Partials/Dialog/CoachNewCharge";

class Overview extends Component {
  protected middlewares: MiddlewareInterface[] = [
    DashboardWillMount
  ];

  public state = {
    activitiesEventsCount: 0,
    unfinishedTasksEventsCount: 0,
    isOpenUnitCoach: false,
    openCoachCreateNewContact: false,
    openCoachCreateNewUnit: false,
    openCoachCreateNewProperty: false,
    openPropertyOwnerCoachDialog: false,
    ownerCreateByCoach: null,
    openPrePropertyOwnerCoachDialog: false,
    ownerType: "company",
    ownerTypeСhose: true,
    defaultCompanyName: "",
    defaultAddress: null,
    openLandlordCoach: false,
    openCoachIncreaseRent: false,
    openCoachCreateNewTenant: false,
    isChargeCreatePopupOpen: false,
    openNewPropertyFirstUserCoach: false,
    isCoachCreateCreditInvoiceOpen: false,
    isCoachNewChargeOpen: false
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    this.setState({
      activitiesEventsCount: nextProps.events.activitiesEventsCount,
      unfinishedTasksEventsCount: nextProps.events.unfinishedTasksEventsCount
    });
  }

  public fetchData = (): void => {
    this.props.dispatch({
      type: Constants.DASHBOARD_FETCH,
      onSuccess: res => {
        this.setState({
          units: res
        });
      }
    });
  }

  public getUnitsNormalizedData = (units) => {
    const unitsArr = [];

    if (!units) {
      return null;
    }

    unitsArr.push({
      name: this.trans("empty"),
      y: units.filter((unit: UnitInterface) => unit.isEmpty && unit.removed === false).length,
      color: "red"
    });
    unitsArr.push({
      name: this.trans("ending"),
      y: units.filter((unit: UnitInterface) => unit.isEnding && unit.removed === false).length,
      color: "orange"
    });
    unitsArr.push({
      name: this.trans("expiring"),
      y: units.filter((unit: UnitInterface) => unit.isExpiring && unit.removed === false).length,
      color: "yellow"
    });

    
    unitsArr.push({
      name: this.trans("label-deactivate"),
      y: units.filter((unit: UnitInterface) => unit?.isInactive && unit.removed === false).length,
      color: "rgb(178, 178, 178)"
    });

    return unitsArr;
  }

  public getTodosAmount = () => {
    const activitiesEventsCount = this.props.app?.settings?.agency?.isActivitiesShown ?
      Number(this.state.activitiesEventsCount) : 0;
    return (
      activitiesEventsCount +
      Number(this.state.unfinishedTasksEventsCount)
    );
  }

  public getTodosNormalizedData = () => {
    const todosArr = [];

    if (this.props.app?.settings?.agency?.isActivitiesShown) {
      todosArr.push({
        name: this.trans("page/dashboard-tab/activities"),
        y: Number(this.state.activitiesEventsCount),
        color: "orange"
      });
    }

    todosArr.push({
      name: this.trans("tasks"),
      y: Number(this.state.unfinishedTasksEventsCount),
      color: "yellow"
    });

    return todosArr;
  }

  public goToUnitsListing = (filter) => {
    this.props.dispatch({
      type: Constants.PAGE_UNITS_UNITS_FILTER,
      payload: {
        filter: filter
      }
    });
    this.redirect(`/app/units/`);
  }

  public openPropertyOwnerCoachDialog  = (defaultCompanyName, defaultAddress) => {
    this.setState({
      openPrePropertyOwnerCoachDialog: true,
      openCoachCreateNewProperty: false,
      defaultCompanyName: defaultCompanyName,
      defaultAddress: defaultAddress
    })
  }


  public renderColumnUnits = () => {
    const units = Object.keys(this.props.units?.byId || {})?.map((id) => this.props.units.byId[id]);
    const countOfUnits = units?.filter((unit: UnitInterface) => unit.removed === false)?.length

    return (
      <div>
        <div className="start-section-header">
          <div className="count-of-entity">{countOfUnits}</div>
          <div className="entity-name">{this.trans("title-units")}</div>
          <div className="registred">{this.trans("page/dashboard-tab/start-section/statistic-label/registred")}</div>
          <div className="click-button-text">{this.trans("page/dashboard-tab/start-section/statistic-info1/unitrental")}</div>
          <div className="click-button-text-left">{this.trans("page/dashboard-tab/start-section/statistic-info2/unitrental")}</div>
          <Button
            color="primary"
            onClick={() => this.setState({
              openNewPropertyFirstUserCoach: true
            })}
            variant="outlined"
            style={{textAlign: "center"}}
          >
            {this.trans("launchpanel-link/newrealestate")}
          </Button>
        </div>
        <div className="start-section-content">
        <div className="content-block">
            <div className="title-section">{this.trans("title-unit")}</div>
            <div className="section-text">{this.trans("page/dashboard-tab/start-section/statistic-info1/unit")}</div>
            <ul>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info2/unit")}</li>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info3/unit")}</li>
            </ul>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openCoachCreateNewUnit: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/newunit")}
              </Button>
            </div>
          </div>

      {/* Removing adding address by user */}
          {/* <div className="content-block">
            <div className="title-section">{this.trans("title-address")}</div>
            <div className="section-text">{this.trans("page/dashboard-tab/start-section/statistic-info1/property")}</div>
            <ul>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info2/property")}</li>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info3/property")}</li>
            </ul>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openCoachCreateNewProperty: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/newproperty")}
              </Button>
            </div>
          </div> */}

          <div className="content-block">
            <div className="title-section">{this.trans("title-landlord")}</div>
            <div className="section-text-margin">{this.trans("page/dashboard-tab/start-section/statistic-info1/landlord")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openPrePropertyOwnerCoachDialog: true, openLandlordCoach: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/newlandlord")}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  public renderColumnContracts = () => {
    const units = Object.keys(this.props.units?.byId || {})?.map((id) => this.props.units.byId[id]);
    const countOfUnits = units?.filter((unit: UnitInterface) => unit.removed === false)?.length
    const countOfEmptyUnits = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id])?.filter((unit: UnitInterface) => unit.removed === false)?.filter((unit: UnitInterface) => unit.isEmpty || unit.isInactive)?.length;
    const countOfContracts = countOfUnits - countOfEmptyUnits;

    return (
      <div>
        <div className="start-section-header">
          <div className="count-of-entity">{countOfContracts}</div>
          <div className="entity-name">{this.trans("contracts")}</div>
          <div className="registred">{this.trans("page/dashboard-tab/start-section/statistic-label/registred")}</div>
          <div className="click-button-text">{this.trans("page/dashboard-tab/start-section/statistic-label/clickbutton")}</div>
          <Button
            color="primary"
            onClick={() => this.setState({openCoachCreateNewContact: true})}
            variant="outlined"
            style={{textAlign: "center", width: "165px"}}
          >
            {this.trans("page/dashboard-tab/start-section/statistic-button/newrentalcontract")}
          </Button>
          <div className="hint-text-start-section">{this.trans("page/dashboard-tab/start-section/statistic-info/includingtenantandoccupant")}</div>
        </div>
        <div className="start-section-content">
        <div className="content-block">
            <div className="title-section">{this.trans("page/dashboard-tab/start-section/statistic-title/contract")}</div>
            <div className="section-text-margin">{this.trans("page/dashboard-tab/start-section/statistic-info1/contract")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openCoachCreateNewContact: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/newcontract")}
              </Button>
            </div>
          </div>

          <div className="content-block">
            <div className="title-section">{this.trans("title-tenant")}</div>
            <div className="section-text">{this.trans("page/dashboard-tab/start-section/statistic-info1/tenant")}</div>
            <ul>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info2/tenant")}</li>
              <li>{this.trans("page/dashboard-tab/start-section/statistic-info3/tenant")}</li>
            </ul>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openCoachCreateNewTenant: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/newtenant")}
              </Button>
            </div>
          </div>

          <div className="content-block">
            <div className="title-section">{this.trans("page/dashboard-tab/start-section/statistic-title/increaserent")}</div>
            <div className="section-text-margin">{this.trans("page/dashboard-tab/start-section/statistic-info1/increaserent")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({openCoachIncreaseRent: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("page/dashboard-tab/start-section/statistic-button/increaserent")}
              </Button>
            </div>
          </div> 
        </div>
      </div>
    );
  }

  public renderColumnCharge = () => {
    return (
      <div>
        <div className="start-section-header">
          <div className="entity-name" style={{marginBottom: "20px"}}>{this.trans("title-charges")}</div>
        </div>
        <div className="start-section-content">
        <div className="content-block">
            <div className="title-section">{this.trans("page/dashboard-tab/start-section/statistic-info1/provideinvoice")}</div>
            <div className="section-text-margin">{this.trans("launchpanel-link/register-an-incoming-invoice")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() =>     
                  this.setState({
                    // isChargeCreatePopupOpen: true,
                    isCoachNewChargeOpen: true
                  })
                }
                variant="outlined"
                style={{textAlign: "center", width: "165px"}}
              >
                {this.trans("launchpanel-link/register-an-incoming-invoice")}
              </Button>
            </div>
          </div>
          
          <div className="content-block">
            <div className="title-section">{this.trans("page/dashboard-tab/start-section/statistic-info1/creditcharge")}</div>
            <div className="section-text-margin">{this.trans("button-create-credit-charge")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.setState({isCoachCreateCreditInvoiceOpen: true})}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("button-create-credit-charge")}
              </Button>
            </div>
          </div>

          <div className="start-section-header">
            <div className="entity-name" style={{marginBottom: "20px"}}>{this.trans("page/dashboard-tab/start-section/statistic-title/statements")}</div>
          </div>
          <div className="content-block">
            <div className="title-section">{this.trans("page/dashboard-tab/start-section/statistic-title/statements")}</div>
              <div className="section-text-margin">{this.trans("page/dashboard-tab/start-section/statistic-info/statements")}</div>
            <div className="button-wrapper">
              <Button
                color="primary"
                onClick={() => this.redirect(`/app/dashboard/statements`)}
                variant="outlined"
                style={{textAlign: "center"}}
              >
                {this.trans("launchpanel-link/send-statements")}
              </Button>
            </div>
          </div>

        </div>
      </div>
    );
  }

  public chooseOwnerType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      ownerType: choice,
      ownerTypeСhose: true
    });
  }

  public openFirstStep = () => {
    this.setState({
      openPropertyOwnerCoachDialog: false,
      openPrePropertyOwnerCoachDialog: true,
    })
  }

  public getCoachContent = () => {
    return (
      <div>
        <div>
          {this.trans("coach/propertyowner-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.ownerType}
            onChange={this.chooseOwnerType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/propertyowner-radiobutton/person")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/propertyowner-radiobutton/company")}
              style={{width: "auto", fontSize: "16px", marginRight: "20px"}}
            />
          </RadioGroup>
        </div>
        <div className="hint-styles">
          {this.trans("coach/propertyowner-scenario/company-step/first-info2")}
        </div>
      </div>
    )
  }

  public closeChargeCreatePopup = () => {
    this.setState({
      isChargeCreatePopupOpen: false
    });
  }

  public onCloseNewPropertyFirstUser = () => {
    this.setState({
      openNewPropertyFirstUserCoach: false
    })
  }

  public render() {
    const units = Object.keys(this.props.units?.byId || {}).map((id) => this.props.units.byId[id]);

    const configUnits = {
      chart: {
        type: "pie",
        options3d: {
          enabled: false,
          alpha: 45
        },
        height: 300,
        width: 400
      },
      title: {
        text: ""
      },
      plotOptions: {
        pie: {
          innerSize: 50,
          depth: 45,
          allowPointSelect: true,
          cursor: "pointer"
        }
      },
      series: [
        {
          name: this.trans("title-units"),
          data: this.getUnitsNormalizedData(units),
          dataLabels: {
            formatter: function() {
              return "<b>" + this.point.name + ":</b> " + this.y;
            },
            style: { fontSize: "14px" }
          }
        }
      ],
      showInLegend: true
    };

    const configTodos = {
      chart: {
        type: "pie",
        options3d: {
          enabled: false,
          alpha: 45
        },
        height: 300,
        width: 400
      },
      title: {
        text: ""
      },
      plotOptions: {
        pie: {
          innerSize: 50,
          depth: 45,
          allowPointSelect: true,
          cursor: "pointer"
        }
      },
      series: [
        {
          name: this.trans("title-todos"),
          data: this.getTodosNormalizedData(),
          dataLabels: {
            formatter: function() {
              return "<b>" + this.point.name + ":</b> " + this.y;
            },
            style: { fontSize: "14px" }
          }
        }
      ],
      showInLegend: true
    };

    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={0}
              {...this.props}
            />
          </div>
          <div className="component-wrapper no-margin-top">
            <div className="component">
              {
                (<Card className="card start-section">
                  <div className="start-section-wrapper" style={{display: "flex"}}>
                      <div className="start-section-column">
                        {this.renderColumnUnits()}
                      </div>
                      <div className="start-section-column">
                        {this.renderColumnContracts()}
                      </div>
                      <div className="start-section-column">
                        {this.renderColumnCharge()}
                      </div>
                  </div>
                </Card>
              )}
            </div>
          </div>

          <div className="component-wrapper no-margin-top">
            <div className="component">
              {units &&
                (<Card className="card units-statistic">
                  <div  className="label-container"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "48px",
                          maxHeight: "48px"
                        }}
                  >
                    <h3 className="card-title">
                      {this.trans("title-units")}
                    </h3>
                  </div>
                  <div className="chart-main-wrapper" style={{display: "flex"}}>
                    <div className="chart-list-wrapper" style={{width: "auto", minWidth: "140px"}}>
                      <div className="chart-list-item" style={{cursor: "default"}}>
                        <span className="amount" style={{color: "#b6b6b6"}}>{units.filter((unit: UnitInterface) => unit.removed === false).length}</span>
                        <span className="title-wrapper">
                          <span className="color-label all"></span>
                          <span className="title">{this.trans("title-units")}</span>
                        </span>
                      </div>
                    </div>
                    <div className="chart-diagram-wrapper">
                      <ReactHighcharts config={configUnits} />
                    </div>
                    <div className="chart-list-wrapper">
                      <div className="chart-list-item" onClick={() => this.goToUnitsListing("empty")}>
                        <span className="amount">{units.filter((unit: UnitInterface) => unit.isEmpty && unit.removed === false).length}</span>
                        <span className="title-wrapper">
                          <span className="color-label empty"></span>
                          <span className="title">{this.trans("empty")}</span>
                        </span>
                      </div>
                      <div className="chart-list-item" onClick={() => this.goToUnitsListing("ending")}>
                        <span className="amount">{units.filter((unit: UnitInterface) => unit.isEnding && unit.removed === false).length}</span>
                        <span className="title-wrapper">
                          <span className="color-label ending"></span>
                          <span className="title">{this.trans("ending")}</span>
                        </span>
                      </div>
                      <div className="chart-list-item" onClick={() => this.goToUnitsListing("expiring")}>
                        <span className="amount">{units.filter((unit: UnitInterface) => unit.isExpiring && unit.removed === false).length}</span>
                        <span className="title-wrapper">
                          <span className="color-label expiring"></span>
                          <span className="title">{this.trans("expiring")}</span>
                        </span>
                      </div>
                      <div className="chart-list-item" onClick={() => this.goToUnitsListing("inactive")}>
                        <span className="amount">{units.filter((unit: UnitInterface) => unit?.isInactive && unit.removed === false).length}</span>
                        <span className="title-wrapper">
                          <span className="color-label inactive"></span>
                          <span className="title">{this.trans("label-deactivate")}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              )}
            </div>
          </div>

          <div className="component-wrapper">
            <div className="component">
              {units &&
                (<Card className="card units-statistic">
                  <div className="label-container"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          height: "48px",
                          maxHeight: "48px"
                        }}
                      >
                    <h3 className="card-title">
                      {this.trans("title-todos")}
                    </h3>
                  </div>
                  <div className="chart-main-wrapper" style={{display: "flex"}}>
                    <div className="chart-list-wrapper" style={{width: "auto", minWidth: "140px"}}>
                      <div className="chart-list-item" style={{cursor: "default"}}>
                        <span className="amount" style={{color: "#b6b6b6"}}>{this.getTodosAmount()}</span>
                        <span className="title-wrapper">
                          <span className="color-label all"></span>
                          <span className="title">{this.trans("title-todos")}</span>
                        </span>
                      </div>
                    </div>
                    <div className="chart-diagram-wrapper">
                      <ReactHighcharts config={configTodos} />
                    </div>
                    <div className="chart-list-wrapper">
                      {
                        this.props.app?.settings?.agency?.isActivitiesShown && (
                          <div className="chart-list-item" onClick={() => this.redirect("/app/dashboard/activities")}>
                            <span className="amount">{Number(this.state.activitiesEventsCount)}</span>
                            <span className="title-wrapper">
                              <span className="color-label ending"></span>
                              <span className="title">{this.trans("page/dashboard-tab/activities")}</span>
                            </span>
                          </div>
                        )
                      }
                      <div className="chart-list-item" onClick={() => this.redirect("/app/dashboard/tasks")}>
                        <span className="amount">{Number(this.state.unfinishedTasksEventsCount)}</span>
                        <span className="title-wrapper">
                          <span className="color-label expiring"></span>
                          <span className="title">{this.trans("unfinished-tasks")}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </Card>
              )}
            </div>
          </div>
        </div>

        {this.state.openCoachCreateNewContact &&
        <CoachNewContractDialog
          {...this.props}
          openCoachCreateNewContact={this.state.openCoachCreateNewContact}
          onCloseContractCoach={(contract) => {    
            this.setState({
              openCoachCreateNewContact: false
            });
            if (contract?.id) {
              this.redirect(`/app/contract/update/${contract?.id}`);
            }
          }}
        />
        }

        {this.state.openCoachIncreaseRent &&
        <CoachIncreaseRentDialog
          {...this.props}
          openCoachIncreaseRent={this.state.openCoachIncreaseRent}
          onCloseIncreaseRentCoach={(contract, success: boolean) => {    
            this.setState({
              openCoachIncreaseRent: false
            })
            if (success) {
              return this.redirect(`/app/contract/update/${contract?.id}`);
            }
          }}
        />
        }

        <CoachNewUnitDialog
          {...this.props}
          openCoachCreateNewUnit={this.state.openCoachCreateNewUnit}
          onCloseUnitCoach={(unit) => {
            this.setState({
              openCoachCreateNewUnit: false
            })
            if (unit) {
              return this.redirect(`/app/unit/update/${unit?.id}`);
            }
          }}
        />

        <CoachNewPropertyDialog
          {...this.props}
          openCoachCreateNewProperty={this.state.openCoachCreateNewProperty}
          openPropertyOwnerCoachDialog={this.openPropertyOwnerCoachDialog}
          onClosePropertyCoach={(property) => {
            this.setState({
              openCoachCreateNewProperty: false,
              ownerCreateByCoach: null
            })
            if (property?.id) {
              this.redirect(`/app/property/update/${property.id}`);
            }
          }}

          ownerCreateByCoach={this.state.ownerCreateByCoach}
          addressAfterOwnerCoach={this.state.defaultAddress}
        />

        <PromptDialog
          {...this.props}
          title={this.trans("coach/propertyowner-title")}
          innerDialogClasses="coach-owner dialog-assistant"
          content={this.getCoachContent()}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("coach/propertyowner-button/next")}
          openLeavePrompt={this.state.openPrePropertyOwnerCoachDialog}
          prioritizeClosing={true}
          onDiscard={() => {
            this.setState({
              openPrePropertyOwnerCoachDialog: false,
              openCoachCreateNewProperty: false
            });
          }}
          onSave={() => {this.setState({ openPrePropertyOwnerCoachDialog: false, openPropertyOwnerCoachDialog: true }); }}
          diableContinueButton={!this.state.ownerTypeСhose}
        />

        <CoachDialog
          {...this.props}
          openPropertyOwnerCoachDialog={this.state.openPropertyOwnerCoachDialog}
          type={this.state.ownerType}
          defaultCompanyName={this.state.defaultCompanyName}
          onCloseCoach={(owner) => {
            this.setState({
              openCoachCreateNewProperty: this.state.openLandlordCoach ? false : true,
              openPropertyOwnerCoachDialog: false,
              ownerCreateByCoach: this.state.openLandlordCoach ? null : owner,
              defaultCompanyName: "",
              openLandlordCoach: false
            })
          }}
          openFirstStep={this.openFirstStep}
        />

        <ChargeCreateDialog 
          isOpened={this.state.isChargeCreatePopupOpen}
          title={this.trans("title-new-charge")}
          isInvoice={true}
          onCancel={this.closeChargeCreatePopup}
          {...this.props}
        />

        <CoachNewTenantDialog
          {...this.props}
          openCoachCreateNewTenant={this.state.openCoachCreateNewTenant}
          onCloseTenantCoach={() => {
            this.setState({
              openCoachCreateNewTenant: false            
            })
          }}
        />

        <CoachNewPropertyFirstUserDialog
          {...this.props}
          openNewPropertyFirstUserCoach={this.state.openNewPropertyFirstUserCoach}
          onCloseNewPropertyFirstUser={this.onCloseNewPropertyFirstUser}
        />

        {this.state.isCoachCreateCreditInvoiceOpen && (
        <CoachCreateCreditInvoice 
          {...this.props}
          isOpen={this.state.isCoachCreateCreditInvoiceOpen}
          onCloseCreateCreditInvoiceCoach={() => {
            this.setState({
              isCoachCreateCreditInvoiceOpen: false, 
              isSaving: false, 
            })
          }}
        />
        )}

        {this.state.isCoachNewChargeOpen && (
          <CoachNewCharge
            {...this.props}
            openCoach={this.state.isCoachNewChargeOpen}
            activeStep={1}
            coachType="Payable"
            onCloseCoach={(success: boolean = false, charge) => {
              this.setState({
                isCoachNewChargeOpen: false
              }, () => {
                if (success) {
                  return this.redirect(`/app/charge/update/${charge.id}`)
                }
              })
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    tasks: state.tasks,
    units: state.units,
    component: state.container,
    globalTypes: state.globalTypes,
    properties: state.properties,
  };
};

export default connect(mapStateToProps)(Overview);
